import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const macrofitnessApiService = createApi({
  reducerPath: "macrofitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createMacro: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `macrofitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getMacro: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `macrofitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateMacro: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `macrofitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateMacroMutation,
  useGetMacroQuery,
  useUpdateMacroMutation,
} = macrofitnessApiService;
